export default __webpack_public_path__ + "static/media/cancelledIcon.954300d2.svg";